module.exports = __webpack_public_path__ + "img/3.fab0e607.png";